import { createSlice } from "@reduxjs/toolkit";
import {
    getAllCompaniesList, 
    getCompanyDetailsByID,
    updateExistingCompany,
    uploadCompanyLogoSquare,
    uploadCompanyLogoWide
} from './thunk';

export const initialState = {
    companyList: [],
    companyDetails: null,
    errors: {}
};

const CompaniesSlice = createSlice({
    name: 'Companies',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        // Company thunks
        builder.addCase(getAllCompaniesList.fulfilled, (state: any, action: any) => {
            state.companyList = action.payload;
        });
        builder.addCase(getAllCompaniesList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getCompanyDetailsByID.fulfilled, (state: any, action: any) => {
            state.companyDetails = action.payload;
        });
        builder.addCase(getCompanyDetailsByID.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(updateExistingCompany.fulfilled, (state: any, action: any) => {
            // Update company details in state
            if (action.payload) {
                state.companyDetails = action.payload;
            }
        });
        builder.addCase(updateExistingCompany.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        
        // Logo upload thunks
        builder.addCase(uploadCompanyLogoSquare.fulfilled, (state: any, action: any) => {
            // Update company details with new logo
            if (action.payload && state.companyDetails) {
                state.companyDetails.company_logo_square = action.payload.company_logo_square_url;
            }
        });
        builder.addCase(uploadCompanyLogoSquare.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
        
        builder.addCase(uploadCompanyLogoWide.fulfilled, (state: any, action: any) => {
            // Update company details with new logo
            if (action.payload && state.companyDetails) {
                state.companyDetails.company_logo_wide = action.payload.company_logo_wide_url;
            }
        });
        builder.addCase(uploadCompanyLogoWide.rejected, (state: any, action: any) => {
            state.error = action.payload?.error || null;
        });
    }
});

export const {
} = CompaniesSlice.actions;

export default CompaniesSlice.reducer;